module.exports = __webpack_public_path__ + "media/images/applicant/bg-flow-dots-4dcba398ab570ff2a30b2a1d0370cbb2.png";